import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment.prod';
import { KeycloakService, KeycloakEventType } from 'keycloak-angular';
import { GlobalErrorHandler } from './global-error-handler';

import { LowerCasePipe, TitleCasePipe, UpperCasePipe, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { ReplaySubject } from 'rxjs';
import { AuthInterceptor } from './http-interceptors/auth.interceptor';
import dayjs from 'dayjs';
registerLocaleData(localeIt);

export const bearerToken = new ReplaySubject<string>(1);

const initializeKeycloak = (keycloak: KeycloakService) => {
  // This is the factory function that APP_INITIALIZER will execute.
  // It must return a Promise.
  return async () => {
    try {
      console.log('Attempting Keycloak initialization...');
      const authenticated = await keycloak.init({
        /* config: {
          url: 'https://sso-websi3dev.teom.it', //192.168.64.3:8080
          realm: 'teom',
          clientId: 'tenant-backend-api',
        }, */
        /* config: {
          url: 'https://sso-websi3.teom.it', //192.168.64.3:8080
          realm: 'teom',
          clientId: 'tenant-backend-api',
        }, */
        /* config: {
          url: 'https://192.168.200.222:8080', //192.168.64.3:8080
          realm: 'teom',
          clientId: 'tenant-backend-api',
        }, */
        /* config: {
          url: 'https://sso-websi3demo.teom.it', //192.168.64.3:8080
          realm: 'teom',
          clientId: 'tenant-backend-api',
        }, */
        config: {
          url: 'https://sso-sorical.teom.it', //192.168.64.3:8080
          realm: 'sorical',
          clientId: 'tenant-backend-api',
        },
        /* config: {
          url: 'http://192.168.200.217:8080', //192.168.64.3:8080
          realm: 'teom',
          clientId: 'tenant-backend-api',
        }, */
        /* config: {
          url: 'https://sso-cpipavia.teom.it', //192.168.64.3:8080
          realm: 'cpipavia',
          clientId: 'tenant-backend-api',
        }, */
        /* config: {
          url: 'https://sso-medline.teom.it', //192.168.64.3:8080
          realm: 'medline',
          clientId: 'tenant-backend-api',
        }, */
        initOptions: {
          flow: 'hybrid', // Using 'hybrid' flow
          checkLoginIframe: false, // Disabling checkLoginIframe
          // onLoad: 'check-sso', // Consider 'check-sso' or 'login-required' based on desired UX
          // silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html', // Needed if using silent check-sso
        },
        // This predicate determines if the KeycloakBearerInterceptor (if used) should add a token.
        // Since you have a custom AuthInterceptor, this might be less critical unless
        // Keycloak's own interceptor is also active.
        shouldAddToken: (_request) => true,
      });

      // Subscribe to Keycloak events to automatically refresh the token.
      // The keycloak-js adapter checks for token expiration automatically in the background.
      /* keycloak.keycloakEvents$.subscribe({
        next: async (event) => {
          if (event.type === KeycloakEventType.OnTokenExpired) {
            console.log('Keycloak token expired, attempting refresh...');
            try {
              const refreshed = await keycloak.updateToken(20); // Refresh if token expires in 20s
              console.log('Token refresh result:', refreshed);
              
              if (refreshed) {
                const token = await keycloak.getToken();
                console.log('Keycloak token refreshed successfully.');
                bearerToken.next(token);
              }
            } catch (error) {
              console.error('Failed to refresh Keycloak token', error);
              // You might want to force a logout here
            }
          }
        }
      }); */

      console.log('Keycloak.init executed. Authenticated:', authenticated);

      if (authenticated) {
        console.log('User is authenticated by Keycloak. Fetching token...');
        const token = await keycloak.getToken();
        const data = dayjs().format('YYYY-MM-DD HH:mm:ss');
        console.log(`Keycloak token fetched successfully at ${data}:`, token);
        bearerToken.next(token);
      } else {
        console.log('User is not authenticated by Keycloak.');
        // Handle non-authenticated state if necessary, e.g., clear local token if your app uses one
        // bearerToken.next(undefined); // Or null, depending on how you signify no token
      }
    } catch (error) {
      console.error('Critical error during Keycloak initialization:', error);
      // Re-throwing the error is important. It signals to Angular that APP_INITIALIZER failed,
      // which should halt the application's bootstrap process.
      throw error;
    }
  };
};
@NgModule({
    declarations: [AppComponent],
    imports: [FormsModule,
              BrowserModule,
              IonicModule.forRoot(),
              AppRoutingModule,
              HttpClientModule,
              BrowserAnimationsModule,
              CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
              NgxPaginationModule,
              NgxGoogleAnalyticsModule.forRoot(environment.ga4MeasurementId),
            ],
    providers: [KeycloakService,
      {
        provide: APP_INITIALIZER,
        useFactory: initializeKeycloak,
        multi: true,
        deps: [KeycloakService]
      }, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      /*{
        // processes all errors
        provide: ErrorHandler,
        useClass: GlobalErrorHandler,
      },*/
      { provide: LOCALE_ID, useValue: 'it-IT'},
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      TitleCasePipe,
      UpperCasePipe,
      LowerCasePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
